/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useMemo, useState } from "react";
import { FlatList, View } from "react-native";
import { useFocusEffect } from "@react-navigation/native";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import { getDBManageOverview } from "@services/api";
import { useDispatch, useSelector } from "react-redux";
import { actions as homeWidgetActions } from "@reducers/homeWidgetReducer";
import ListTile from "./components/ListTile";

const DbManagement = ({ navigation, route }) => {
  const [data, setData] = useState({});

  const { isStarCpHasActiveDbs = false } = useSelector(
    ({ configReducer }) => configReducer,
  );
  const { "db-management": dbManagement = {} } = useSelector(
    (state) => state.homePageWidget?.widgets,
  );
  const dispatch = useDispatch();
  const { nav_params } = dbManagement;
  const fetchData = async () => {
    try {
      // eslint-disable-next-line no-shadow
      const { data } = await getDBManageOverview();
      setData(data?.data);
      dispatch(homeWidgetActions.fetchHomePageWidget());
    } catch (error) {
      console.error("Error fetching DB management overview:", error);
    }
  };

  useFocusEffect(
    useCallback(() => {
      fetchData();
    }, []),
  );

  const listData = useMemo(
    () => [
      {
        title: "Routing",
        type: "ROUTING",
        subtitle_1: "Pending Customers :",
        subtitle_1_value:
          nav_params?.routing_pending_cx || data?.routing_pending_cx,
        subtitle_2: "DB Unassigned Routes: ",
        subtitle_2_value: data?.routing_unassigned_cpdb_routes,
        nav_to: "Routing",
        show_card: nav_params?.routing,
        nav_params_data: {
          ofd_pending_cx:
            nav_params?.routing_pending_cx || data?.routing_pending_cx,
          routing_unassigned_cpdb_routes: data?.routing_unassigned_cpdb_routes,
        },
      },
      {
        title: "Out For Delivery",
        type: "OUT_FOR_DELIVERY",
        subtitle_1: "Pending Customers :",
        subtitle_1_value: nav_params?.ofd_pending_cx,
        nav_to: "OutForDelivery",
        show_card: nav_params?.out_for_delivery,
        nav_params_data: {},
      },
      {
        title: "Manage Delivery Boy",
        type: "MANAGE_DELIVERY_BOY",
        subtitle_1: "Total delivery boy :",
        subtitle_1_value: data?.active_dbs,
        nav_to: isStarCpHasActiveDbs ? "CreateDbOrList" : "CpDeliveryBoys",
        show_card: nav_params?.manage,
        nav_params_data: {},
      },
    ],
    [data, nav_params],
  );

  const renderItem = ({ item }) => <ListTile item={item} />;

  return (
    <View style={{ flex: 1, backgroundColor: "#fff" }}>
      <HeaderWithBackAndTitle
        headertitle="Delivery Management"
        headerColor="#fff"
        hideShadow={true}
        navigation={navigation}
        route={route}
      />
      <FlatList
        data={listData}
        keyExtractor={(item) => item.type}
        renderItem={renderItem}
      />
    </View>
  );
};

export default DbManagement;
